<template>
  <q-tooltip
    transition-show="jump-up"
    transition-hide="jump-down"
    anchor="top middle"
    self="bottom middle"
    class="tw-bg-grey-900 tw-text-white"
    max-width="600px"
  >
    <slot />
  </q-tooltip>
</template>

<style lang="scss">
.q-transition--tooltip-slide-in-enter-active,
.q-transition--tooltip-slide-out-leave-active {
  transition:
    transform 0.25s ease-out,
    opacity 0.25s ease-out;
}

.q-transition--tooltip-slide-in-enter-from,
.q-transition--tooltip-slide-out-leave-to {
  opacity: 0;
  transform: translateX(-10%);
}
</style>
